<template>
  <div>
    <AppTooltip>
      <template #activator="{ props }">
        <div v-bind="props">
          <v-menu location="left" min-width="150">
            <template #activator="{ props }">
              <app-button
                type="icon"
                v-bind="props"
                data-locator="qa-question-actions-menu-button"
              >
                <app-icon-ds
                  icon="ellipsis"
                  size="xs"
                />
              </app-button>
            </template>

            <v-list class="py-0">
              <template v-for="(item, i) in items" :key="`itemMenu-${i}`">
                <AppTooltip
                  v-if="item.action === 'edit' && !canEditQuestion"
                  location="left"
                >
                  <template #activator="{ props }">
                    <!-- We use a wrapper div to retain the disable styling and the tooltip hover event -->
                    <div v-bind="props">
                      <v-list-item
                        disabled
                        data-locator="qa-edit-question-button"
                        @click="handleMenuAction(item.action)"
                      >
                        <template #prepend v-if="item.icon">
                          <app-icon-ds
                            class="mr-4"
                            :icon="item.icon"
                            size="xs"
                          />
                        </template>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </div>
                  </template>
                  <span>{{ $t('project.question-answer.QuestionAnswerDataTable.menuEditDisableText') }}</span>
                </AppTooltip>

                <v-list-item
                  v-else
                  :class="{ 'text-error': item.action === 'delete' }"
                  :data-locator="getMenuItemLocator(item.action)"
                  @click="handleMenuAction(item.action)"
                >
                  <template #prepend v-if="item.icon">
                    <app-icon-ds
                      class="mr-4"
                      :icon="item.icon"
                      :color="item.action === 'delete' ? 'text-error' : undefined"
                      size="xs"
                    />
                  </template>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
              </template>
            </v-list>
          </v-menu>
        </div>
      </template>

      <span>{{ $t('common.additionalActions') }}</span>
    </AppTooltip>

    <!-- DIALOGS -->
    <QuestionAnswerQuestionDeleteDialog
      v-model:question-id="deleteQuestionDialogData.questionId"
      :is-open="deleteQuestionDialogData.isOpen"
      @onClose="closeQuestionDeleteDialog"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { QA_STATUS } from '@/common/utils/qa-status'
import QuestionAnswerQuestionDeleteDialog from '@/project/question-answer/QuestionAnswerQuestionDeleteDialog.vue'
import { QUESTION_ANSWER_EDIT_ROUTE_NAME } from '@/router'

export default {
  name: 'QuestionAnswerDataTableItemMenu',
  components: {
    AppTooltip,
    QuestionAnswerQuestionDeleteDialog,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      deleteQuestionDialogData: {
        isOpen: false,
        questionId: null,
      },
      QA_STATUS,
      QUESTION_ANSWER_EDIT_ROUTE_NAME,
    }
  },
  computed: {
    ...mapGetters('room', ['roomMnemo']),
    ...mapGetters('user', ['currentUserId']),
    ...mapGetters('room', ['isCurrentUserPm']),
    canEditQuestion () {
      return this.item.status === QA_STATUS.TO_ANSWER
    },
    items () {
      const menu = []
      if (this.item.userId === this.currentUserId) {
        menu.push({
          icon: 'pen-to-square',
          text: this.$t('project.question-answer.QuestionAnswerDataTable.menu.edit'),
          action: 'edit',
        })
      }
      if (this.isCurrentUserPm || this.item.rights.canWrite) {
        menu.push({
          icon: 'trash-can',
          text: this.$t('project.question-answer.QuestionAnswerDataTable.menu.delete'),
          action: 'delete',
        })
      }
      return menu
    },
  },
  methods: {
    getMenuItemLocator (action) {
      switch (action) {
        case 'edit':
          return 'qa-edit-question-button'
        case 'delete':
          return 'qa-delete-question-button'
        default:
          return null
      }
    },
    handleMenuAction (action) {
      switch (action) {
        case 'edit':
          this.onEditQuestion(this.item.id)
          break
        case 'delete':
          this.openQuestionDeleteDialog(this.item.id)
          break
      }
    },
    onEditQuestion (questionId) {
      this.$router.push({
        name: QUESTION_ANSWER_EDIT_ROUTE_NAME,
        params: {
          mnemo: this.roomMnemo,
          questionId,
        },
      })
    },
    openQuestionDeleteDialog (questionId) {
      this.deleteQuestionDialogData = {
        questionId,
        isOpen: true,
      }
    },
    closeQuestionDeleteDialog () {
      this.deleteQuestionDialogData = {
        questionId: null,
        isOpen: false,
      }
    },
  },
}
</script>
